import { render, staticRenderFns } from "./CustomerImportEmptyState.vue?vue&type=template&id=5c13cdd9&scoped=true&"
import script from "./CustomerImportEmptyState.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportEmptyState.vue?vue&type=style&index=0&id=5c13cdd9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13cdd9",
  null
  
)

export default component.exports